import { FaqWrapper, FaqContainer, Title, FaqItem, Head, Body } from './EarnFAQ.styles';
import React, { useState } from 'react';
import { IconChevron } from '@components/icons';
import Link from '@components/common/Link';

export function EarnFAQ() {
  /// We start at 1, so 0 can allow all to start closed
  const [openIndex, setOpenIndex] = useState(0);
  const clickHandler = (index: number) => {
    setOpenIndex(openIndex === index ? 0 : index);
  };
  return (
    <FaqWrapper>
      <FaqContainer>
        <Title type="h1">FAQ</Title>
        <FaqItem isOpen={openIndex === 1}>
          <Head onClick={() => clickHandler(1)}>
            Where is the liquidity pool APY coming from? <IconChevron />
          </Head>
          <Body>
            <p>
              Our <b>3CRV/lvUSD Pool APY</b> is achieved from emission rewards from our native ARCH Token. Additional
              APY will come in the form of OUSD and the different protocols we support (as well as CRV). ARCH actually
              has utility as well as being our governance token.
            </p>
            <p>
              Leverage Takers (Borrowers) can only open a leverage position by purchasing leverage (lvUSD) with ARCH.
              With this leverage fee we hope create high demand for ARCH tokens.
            </p>
          </Body>
        </FaqItem>
        <FaqItem isOpen={openIndex === 2}>
          <Head onClick={() => clickHandler(2)}>
            Why should I provide liquidity to Archimedes? <IconChevron />
          </Head>
          <Body>
            <p>At Archimedes we are obsessively focused on providing small and large Liquidity providers with:</p>
            <ul>
              <li>
                <b>Top of market APY</b>
              </li>
              <li>
                <b>Sustainable APY</b>
              </li>
            </ul>
            <p>
              You can read more about how we achieve this{' '}
              <Link
                href="https://docs.archimedesfi.com/liquidity-providing-(lender)/why-provide-liquidity-with-archimedes"
                target="_blank"
                rel="noreferrer"
              >
                here.
              </Link>
            </p>
          </Body>
        </FaqItem>
        <FaqItem isOpen={openIndex === 3}>
          <Head onClick={() => clickHandler(3)}>
            How much APY am I going to get as a LP?
            <IconChevron />
          </Head>
          <Body>
            <p>
              This is hard to predict but we aim to provide a <b>Top of Market APY.</b>
            </p>
            <p>
              We use an innovative and Dynamic ARCH Emission schedule, you can read more about it{' '}
              <Link
                href="https://docs.archimedesfi.com/tokenomics-and-ecosystem/arch-dynamic-emissions"
                target="_blank"
                rel="noreferrer"
              >
                here.
              </Link>
            </p>
          </Body>
        </FaqItem>
        <FaqItem isOpen={openIndex === 4}>
          <Head onClick={() => clickHandler(4)}>
            How can I be sure that lvUSD will remain pegged?
            <IconChevron />
          </Head>
          <Body>
            <p>
              Read more about how we maintain the peg for lvUSD{' '}
              <Link
                href="https://docs.archimedesfi.com/liquidity-providing-(lender)/risks-of-providing-liquidity#0f9e44d0755a40b88c0f1a7857a5cfb3"
                target="_blank"
                rel="noreferrer"
              >
                here
              </Link>
              .
            </p>
          </Body>
        </FaqItem>
        <FaqItem isOpen={openIndex === 5}>
          <Head onClick={() => clickHandler(5)}>
            How do I provide liquidity?
            <IconChevron />
          </Head>
          <Body>
            <p>
              Read our Step-by-Step guide to providing liquidity{' '}
              <Link
                href="https://docs.archimedesfi.com/liquidity-providing-(lender)/how-to-provide-liquidity-(step-by-step)"
                target="_blank"
                rel="noreferrer"
              >
                here
              </Link>
              .
            </p>
          </Body>
        </FaqItem>
      </FaqContainer>
    </FaqWrapper>
  );
}
